
<a @items *ngFor="let menu of menuList ;let i = index" mat-button matLine [routerLink]="menu.link" class="menu-item" [class.selected-menu]="isCurrentRoute(menu)" (click)="menu_onClick(menu)">
  <mat-icon class="font-icon" *ngIf="menu.fontIcon">{{menu.fontIcon}}</mat-icon>
  <img *ngIf="menu.icon" class="img-icon" src={{menu.icon}}>
  <span class="link-white">{{menu.name}}</span>
</a>
